import React from 'react';
import Loadable from 'react-loadable';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import hubConfig from '../../../../config/hubs';

let PageComponent = false;
let DefaultHubPageComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  PageComponent = require('./most_innovative_companies_hub_page').default;
  // eslint-disable-next-line global-require
  DefaultHubPageComponent = require('./default_hub_page').default;
}

export function micHubPage(store) {
  const routeConfig = {
    path: '/:tag(most-innovative-companies)',
    component() {
      if (PageComponent) {
        return <PageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: PageComponent ? PageComponent.loadData(store) : false,
    preloadChunk() {
      return import('./most_innovative_companies_hub_page').then(resp => {
        PageComponent = resp.default;
        routeConfig.loadData = PageComponent.loadData(store);

        return PageComponent;
      });
    },
    chunk: 'micHubPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

export function defaultHubPage(store) {
  const routeConfig = {
    path: `/:tag(${Object.keys(hubConfig).join('|')})`,
    component() {
      if (DefaultHubPageComponent) {
        return <DefaultHubPageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: DefaultHubPageComponent
      ? DefaultHubPageComponent.loadData(store)
      : false,
    preloadChunk() {
      return import('./default_hub_page').then(resp => {
        DefaultHubPageComponent = resp.default;
        routeConfig.loadData = DefaultHubPageComponent.loadData(store);

        return DefaultHubPageComponent;
      });
    },
    chunk: 'micHubPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
